<template>
  <!-----Checkout form modal------->
  <div
    class="modal right fade ss-checkout-form-modal"
    id="CheckoutformypeModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="checkout-head mb-4">
            <h3 class="mb-0">
              {{ showCheckoutFormPopUp ? "SAVE CHECKOUT FORM" : "CHECKOUT FORMS" }}
            </h3>
            <!-- <h3 class="mb-0 d-none">
              <span class="mr-3"
                ><v-icon dark color="#333" size="25px"
                  >mdi-arrow-left</v-icon
                ></span
              >
              ADD CHECKOUT FORMS
            </h3> -->
            <div class="close-check" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </div>
          </div>
          <div class="create-form-class final-button" v-if="!showCheckoutFormPopUp">
            <v-btn
              color="#2376e5"
              class="save-standard"
              dark
              large
              @click="addCheckoutForm()"
              ><span class="mr-2"
                ><img src="../assets/Images/reg-ico/create-new-reg-type.svg"
              /></span>
              Create New</v-btn
            >
          </div>
          <div class="table-wrap-class" v-if="!showCheckoutFormPopUp">
            <v-simple-table>
              <thead>
                <tr>
                  <!-- <th>
                    <v-checkbox
                      v-model="ex4"
                      color="primary"
                      hide-details
                    ></v-checkbox>
                  </th> -->
                  <th class="text-left">
                    Form Name
                    <!-- <span
                      ><img src="../assets/Images/reg-ico/table-filter.svg"
                    /></span> -->
                  </th>
                  <!-- <th class="text-left">Type</th> -->
                  <th class="text-left">Reg Type(s)</th>
                  <th class="text-left">Status</th>
                  <th class="text-left">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(form, index) in CheckoutFormList" :key="index">
                  <!-- <td>
                    <v-checkbox color="primary" hide-details></v-checkbox>
                  </td> -->
                  <td>{{ form.FormTitle }}</td>
                  <!-- <td>
                    {{
                      form.RegistrationTypes.map((row) => {
                        return row.FormType;
                      }).toString()
                    }}
                  </td> -->
                  <td>
                    {{ form.RegistrationTypes.length }} Ticket
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon dark color="#333" size="25px" v-bind="attrs" v-on="on"
                          >mdi-information-outline</v-icon
                        >
                      </template>
                      <span>{{
                        form.RegistrationTypes.map((row) => {
                          return row.RegistrationType;
                        }).toString()
                      }}</span>
                    </v-tooltip>
                  </td>
                  <td>
                    <v-switch
                      v-model="CheckoutFormList[index].IsPublished"
                      @change="changeCheckoutFormsStatus(form.IsPublished, form.FormId)"
                    ></v-switch>
                  </td>
                  <td>
                    <!-- <ul>
                      <li>
                        <v-icon dark color="#333" size="25px"
                          >mdi-content-copy</v-icon
                        >
                      </li>
                      <li><img src="../assets/Images/reg-ico/edit.svg" @click="editCheckoutForm(form.FormId)" /></li>
                    </ul> -->
                    <v-btn icon color="black" @click="editCheckoutForm(form.FormId)">
                      <v-icon>mdi-square-edit-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
          <div class="add-chek-out-form-wrap" v-if="showCheckoutFormPopUp">
            <label>Form Name*</label>
            <input type="text" v-model="checkoutFormData.FormTitle" />

            <label
              >Assign to Registration Type
              <span
                ><v-icon dark color="#333" size="25px"
                  >mdi-information-outline</v-icon
                ></span
              ></label
            >
            <v-select
              :items="RegistrationTypeList"
              chips
              label="RegistrationType"
              item-text="RegistrationType"
              v-model="checkoutFormData.RegistrationTypes"
              multiple
              solo
              return-object
              ref="regtype"
              :rules="[() => !!regtype || 'This field is required']"
            ></v-select>
            <hr />
            <div class="self-questions mb-3">
              <h5 class="mb-5">Questions</h5>
              <draggable
                :list="checkoutFormData.DefaultFields"
                :group="{ name: 'tags', pull: 'clone', put: false }"
                v-if="!showFieldForm"
              >
                <div
                  class="single-question mb-2"
                  v-for="(field, findex) in checkoutFormData.DefaultFields"
                  :key="findex"
                >
                  <div class="question-left">
                    <v-icon dark color="#333" size="25px">mdi-drag-vertical</v-icon>
                    <!-- <v-icon dark color="#333" size="25px">{{field.Type == 'email' ? 'mdi-at' : 'mdi-menu'}}</v-icon> -->
                    <p>{{ field.Label }}{{ field.Mandatory ? "*" : "" }}</p>
                  </div>
                  <span
                    ><v-icon
                      dark
                      color="#333"
                      size="25px"
                      class="mr-2"
                      @click="openfieldForm(findex)"
                      >mdi-square-edit-outline</v-icon
                    ><v-icon
                      color="red"
                      size="25px"
                      v-if="!field.StaticField"
                      @click="checkoutFormData.DefaultFields.splice(findex, 1)"
                      >mdi-trash-can-outline</v-icon
                    ></span
                  >
                </div>
              </draggable>
              <v-row v-if="showFieldForm">
                <v-col
                  cols="12"
                  sm="6"
                  class="question-checkout-wrap drop-checkot-wrap mb-4"
                >
                  <label>Question Type</label>
                  <v-select
                    :disabled="
                      checkoutFormData.DefaultFields[fieldIndex].StaticField
                        ? true
                        : false
                    "
                    v-model="checkoutFormData.DefaultFields[fieldIndex].Type"
                    :items="InputTypes"
                    item-text="Name"
                    item-value="Value"
                    @change="
                      setFieldType(checkoutFormData.DefaultFields[fieldIndex], fieldIndex)
                    "
                  />
                </v-col>
                <v-col
                  cols="6"
                  sm="6"
                  class="question-checkout-wrap text-field-chekout mb-4"
                >
                  <label>Question Text</label>
                  <v-text-field
                    v-model="checkoutFormData.DefaultFields[fieldIndex].Label"
                    @blur="setFieldName(checkoutFormData.DefaultFields[fieldIndex])"
                    placeholder="Enter Question"
                    ref="questiontext"
                    :rules="[() => !!questiontext || 'This field is required']"
                    required
                  />
                </v-col>
                <v-col cols="6" sm="6">
                  <label>Field Size</label>
                  <v-slider
                    v-model="checkoutFormData.DefaultFields[fieldIndex].ColumnSize"
                    min="1"
                    max="12"
                    step="1"
                    thumb-label="always"
                  ></v-slider>
                </v-col>
                <v-col cols="6" sm="6">
                  <label>Required</label>
                  <v-switch
                    color="#1a73e8"
                    v-model="checkoutFormData.DefaultFields[fieldIndex].Mandatory"
                  />
                </v-col>
                <v-col
                  cols="12"
                  v-if="
                    ['radio', 'select', 'multiselect'].includes(
                      checkoutFormData.DefaultFields[fieldIndex].Type
                    )
                  "
                >
                  <v-btn
                    small
                    outlined
                    color="green"
                    @click="checkoutFormData.DefaultFields[fieldIndex].Options.push(null)"
                    ><v-icon left> mdi-plus </v-icon>Options</v-btn
                  >
                  <v-row>
                    <v-col
                      cols="6"
                      v-for="(optionVal, index) in checkoutFormData.DefaultFields[
                        fieldIndex
                      ].Options"
                      :key="index"
                    >
                    <div class="d-flex justify-center">
                      <v-icon                        
                        color="red darken-2"
                        @click="
                          checkoutFormData.DefaultFields[fieldIndex].Options.splice(
                            index,
                            1
                          )
                        "
                      >
                        mdi-delete
                      </v-icon>
                      <v-text-field
                        v-model="
                          checkoutFormData.DefaultFields[fieldIndex].Options[index]
                        "
                      />
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <div class="final-button d-flex justify-center">
                <v-btn
                  class="mx-0"
                  outlined
                  color="#2376e5"
                  @click="openfieldForm(null)"
                  v-if="!showFieldForm"
                  >Add Question</v-btn
                >             
                <v-btn
                  class="mt-7"
                  depressed
                  outlined
                  color="#2376e5"
                  @click="savefieldForm()"
                  v-if="showFieldForm"
                  >Save Question</v-btn
                >
              </div>
            </div>
            <div class="d-flex justify-content-end mt-12" v-if="!showFieldForm">
              <v-btn
                class="my-0 ml-0 mr-2 cancel-standard"
                min-width="100"
                depressed
                outlined
                color="#1c1d26"
                @click="showCheckoutFormPopUp = false"
                >Cancel</v-btn
              >
              <v-btn
                min-width="100"
                dark
                color="#2376e5"
                class="save-standard"
                @click="saveCheckoutForm()"
                >Save</v-btn
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-----Checkout form modal------->
</template>
<script>
import APIs from "@/components/APIInit";
var self;
import axios from "axios";
import draggable from "vuedraggable";
import { bus } from "@/main";

export default {
  data() {
    return {
      eventid: null,
      clientID: null,
      event_collectionName: null,
      userID: null,
      blankRules: [(v) => !!v || "This field is required"],
      showCheckoutFormPopUp: false,
      RegistrationTypeList: [],
      CheckoutFormList: [],
      checkoutFormData: {
        FormTitle: null,
        RegistrationTypes: [],
        DefaultFields: [],
        PreSignupFields: null,
        DynamicFields: [],
        IsPublished: true,
      },
      InputTypes: [
        { Name: "Emailbox", Value: "email" },
        { Name: "Textbox", Value: "text" },
        { Name: "Big Textbox", Value: "textarea" },
        { Name: "Radio Button", Value: "radio" },
        { Name: "Single Checkbox", Value: "checkbox" },
        { Name: "Single Dropdown", Value: "select" },
        { Name: "Multiselect Dropdown", Value: "multiselect" },
        { Name: "Profile Picture", Value: "profilepicture" },
        { Name: "Country & State", Value: "country&state" },
      ],
      showFieldForm: false,
      fieldIndex: null,
    };
  },
  components: { draggable },
  computed: {},
  watch: {},
  async created() {
    self = this;
    self.clientID = self.getClientId();
    self.eventid = self.getEventId();
    self.event_collectionName = self.getEventCollectionName();
    self.userID = self.getSessionUserId();
    await self.getRegistrationTypes();
  },
  mounted() {},
  methods: {
    setFieldName(field) {
      if (
        !field.StaticField &&
        !["profilepicture", "country&state"].includes(field.Type)
      ) {
        field.Name = field.Label ? field.Label.trim().replace(/ +/g, "") : null;
      }
    },
    setFieldType(field, findex) {
      delete this.checkoutFormData.DefaultFields[findex]["Country"];
      delete this.checkoutFormData.DefaultFields[findex]["State"];
      if (field.Type == "country&state") {
        field.Name = "Country & State";
        field.Label = "Country & State";
        this.checkoutFormData.DefaultFields[findex]["Country"] = null;
        this.checkoutFormData.DefaultFields[findex]["State"] = null;
      } else if (field.Type == "profilepicture") {
        field.Name = "ProfilePictureURL";
        field.Label = "Profile Picture";
      } else {
        field.Label = "";
      }
    },
    savefieldForm() {
      if (!self.checkoutFormData.DefaultFields[self.fieldIndex].Label) {
        self.showSnackbar("Please enter question text!", "error", "top");
        return false;
      } 
      else if(['radio', 'select', 'multiselect'].includes(self.checkoutFormData.DefaultFields[self.fieldIndex].Type))
      {
        if(!self.checkoutFormData.DefaultFields[self.fieldIndex].Options || !self.checkoutFormData.DefaultFields[self.fieldIndex].Options[0]){
          self.showSnackbar("Please enter option!", "error", "top");
          return false;
        }
      }

      self.showFieldForm = false;

      //self.fieldIndex = null;
      // if(self.fieldIndex == null){
      //   self.checkoutFormData.DefaultFields.push(self.fieldFormData);
      // }
    },
    openfieldForm(findex) {
      self.fieldIndex = findex;
      if (self.fieldIndex == null) {
        let rowObj = {
          Type: "text",
          Name: "CustomField",
          Label: "",
          PlaceHolder: null,
          Order: 4,
          ColumnSize: 6,
          Mandatory: false,
          Options: [],
          value: null,
          ShowInVisitor: false,
        };
        self.checkoutFormData.DefaultFields.push(rowObj);
        self.fieldIndex = self.checkoutFormData.DefaultFields.length - 1;
      }
      self.showFieldForm = true;
    },
    getRegistrationTypes() {
      self.showRegTypeFormPopUp = false;
      bus.$emit("toggleLoader", true);
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${self.getSessionToken()}`,
        };
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: self.clientID,
            eventId: self.eventid,
          },
          data: {
            filter: [
              {
                key: "RegistrationType",
                operator: "!=",
                value: "null",
              },
            ],
            collection: "RegistrationTicketList/RegistrationTicketTypes",
            dockey: "RegistrationTypeId",
          },
        };
        axios
          .post(APIs.getCollectionDocsAPI, requestData, { headers: headers })
          .then(function (res) {
            bus.$emit("toggleLoader", false);
            if (res.data.status == 0 && res.data.result.length) {
              self.RegistrationTypeList = res.data.result.map((item) => {
                if (item.IsPublished) {
                  return {
                    ColorCode: item.ColorCode,
                    Currency: item.Currency,
                    FormType: item.FormType,
                    Price: item.Price,
                    RegistrationType: item.RegistrationType,
                    RegistrationTypeId: item.RegistrationTypeId,
                  };
                }
              });
              resolve(res.data.result);
            }
          })
          .catch((err) => {
            bus.$emit("toggleLoader", false);
            reject(err);
          });
      });
    },
    changeCheckoutFormsStatus(value, FormId) {
      bus.$emit("toggleLoader", true);
      let key = { FormId: FormId };
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${self.getSessionToken()}`,
        instanceId: "OA_UAT",
        clientId: self.clientID,
        eventId: self.eventid,
      };
      let requestData = {
        key: key,
        data: { IsPublished: value },
      };
      axios
        .put(APIs.saveCheckoutForm, requestData, { headers: headers })
        .then(function (res) {
          bus.$emit("toggleLoader", false);
          if (res.data.status == 0) {
            self.showSnackbar("Data Updated!", "success", "top");
          } else {
            self.showSnackbar("Data not Updated!", "error", "top");
          }
        })
        .catch(() => {
          bus.$emit("toggleLoader", false);
          self.showSnackbar("Something Went Wrong!", "error", "top");
        });
    },
    getAllCheckoutForms() {
      self.showCheckoutFormPopUp = false;
      self.showFieldForm = false;
      bus.$emit("toggleLoader", true);
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${self.getSessionToken()}`,
        };
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: self.clientID,
            eventId: self.eventid,
          },
          data: {
            filter: [
              {
                key: "FormTitle",
                operator: "!=",
                value: "null",
              },
            ],
            collection: "FormList/CheckoutForms",
            dockey: "FormId",
          },
        };
        axios
          .post(APIs.getCollectionDocsAPI, requestData, { headers: headers })
          .then(function (res) {
            bus.$emit("toggleLoader", false);
            if (res.data.status == 0 && res.data.result.length) {
              self.CheckoutFormList = res.data.result;
              resolve(res.data.result);
            }
          })
          .catch((err) => {
            bus.$emit("toggleLoader", false);
            reject(err);
          });
      });
    },
    async addCheckoutForm() {
      bus.$emit("toggleLoader", true);
      self.checkoutFormData = await self.fetchCheckoutForm(null).catch();
      self.showCheckoutFormPopUp = true;
      bus.$emit("toggleLoader", false);
    },
    async editCheckoutForm(id) {
      bus.$emit("toggleLoader", true);
      self.checkoutFormData = await self.fetchCheckoutForm(id).catch();
      self.showCheckoutFormPopUp = true;
      bus.$emit("toggleLoader", false);
    },
    fetchCheckoutForm(id) {
      return new Promise((resolve, reject) => {
        if (id === null) {
          resolve({
            FormTitle: null,
            RegistrationTypes: [],
            PreSignupFields: {
              HTMLbody:
                "<p style='text-align: justify;'><strong>By accepting the submit button, you agree to the below terms and conditions</strong> </p>  <p style='text-align: justify;'>I authorize to contact me through various marketing channels such as Email, WhatsApp, SMS and Calls during and before the event.</p><p style='text-align: justify;'>Rights of admission at the event is reserved and is at the sole discretion of the management.</p>",
              RequireAcceptance: true,
              AcceptanceValidationDisplayLabel: "Please accept terms and conditions.",
              AcceptanceDisplayText: "I Accept",
              OptInOne: "Get important updates on WhatsApp, email, and SMS",
              OptInOneIsRequired: false,
              OptInTwo:
                "We may share your name and email address with sponsors whose booths you visit. Please check this box if you would like to be excluded from these lists.",
              OptInTwoIsRequired: false,
            },
            DefaultFields: [
              {
                Type: "text",
                Name: "FirstName",
                Label: "First Name",
                PlaceHolder: "Enter First Name",
                Order: 1,
                ColumnSize: 6,
                Mandatory: true,
                StaticField: true,
                Options: [],
                value: null,
                ShowInVisitor: true,
              },
              {
                Type: "text",
                Name: "LastName",
                Label: "Last Name",
                PlaceHolder: "Enter Last Name",
                Order: 2,
                ColumnSize: 6,
                Mandatory: true,
                StaticField: true,
                Options: [],
                value: null,
                ShowInVisitor: true,
              },
              {
                Type: "email",
                Name: "Email",
                Label: "Email Address",
                PlaceHolder: "Enter Your Email",
                Order: 3,
                ColumnSize: 12,
                Mandatory: true,
                StaticField: true,
                Options: [],
                value: null,
                ShowInVisitor: true,
              },
              {
                Type: "text",
                Name: "Company",
                Label: "Company",
                PlaceHolder: "Enter Company",
                Order: 4,
                ColumnSize: 6,
                Mandatory: false,
                StaticField: true,
                Options: [],
                value: null,
                ShowInVisitor: false,
              },
              {
                Type: "text",
                Name: "Designation",
                Label: "Designation",
                PlaceHolder: "Enter Designation",
                Order: 4,
                ColumnSize: 6,
                Mandatory: false,
                StaticField: true,
                Options: [],
                value: null,
                ShowInVisitor: false,
              },
            ],
            DynamicFields: [],
            IsPublished: true,
          });
        } else {
          let headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${self.getSessionToken()}`,
            instanceId: "OA_UAT",
            clientId: self.clientID,
            eventId: self.eventid,
          };
          axios
            .get(`${APIs.getCheckoutFormDetail}?Id=${id}`, {
              headers: headers,
            })
            .then(function (res) {
              if (res.data.status == 0) {
                let data = res.data.result;
                data.FormTitle = data.FormTitle ? data.FormTitle : null;
                data.RegistrationTypes = data.RegistrationTypes
                  ? data.RegistrationTypes
                  : [];
                data.DefaultFields = data.DefaultFields ? data.DefaultFields : [];
                data.PreSignupFields = data.PreSignupFields ? data.PreSignupFields : null;
                data.DynamicFields = data.DynamicFields ? data.DynamicFields : [];
                data.IsPublished = data.IsPublished ? true : false;
                resolve(data);
              }
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    saveCheckoutForm() {
      if (!self.checkoutFormData.RegistrationTypes.length) {
        self.showSnackbar("Please select registration type!", "error", "top");
        return false;
      }
      bus.$emit("toggleLoader", true);
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${self.getSessionToken()}`,
        instanceId: "OA_UAT",
        clientId: self.clientID,
        eventId: self.eventid,
      };
      let requestData = {
        key: {
          FormId: self.checkoutFormData.FormId,
        },
        data: {
          FormTitle: self.checkoutFormData.FormTitle,
          RegistrationTypes: self.checkoutFormData.RegistrationTypes,
          DefaultFields: self.checkoutFormData.DefaultFields,
          PreSignupFields: self.checkoutFormData.PreSignupFields,
          DynamicFields: self.checkoutFormData.DynamicFields,
          IsPublished: self.checkoutFormData.IsPublished,
        },
      };

      if (self.checkoutFormData.FormId) {
        axios
          .put(APIs.saveCheckoutForm, requestData, {
            headers: headers,
          })
          .then(async function (res) {
            bus.$emit("toggleLoader", false);
            if (res.data.status == 0) {
              self.showSnackbar("Data Updated", "success", "top");
              self.checkoutFormData = await self.fetchCheckoutForm(null).catch();
              self.getAllCheckoutForms();
            } else {
              self.showSnackbar("Data not Updated!", "error", "top");
            }
          })
          .catch(() => {
            bus.$emit("toggleLoader", false);
            self.showSnackbar("Something went wrong!", "error", "top");
          });
      } else {
        axios
          .post(APIs.saveCheckoutForm, requestData, {
            headers: headers,
          })
          .then(async function (res) {
            bus.$emit("toggleLoader", false);
            if (res.data.status == 0) {
              self.showSnackbar("Data Added", "success", "top");
              self.checkoutFormData = await self.fetchCheckoutForm(null).catch();
              self.getAllCheckoutForms();
            } else {
              self.showSnackbar("Data not Added!", "error", "top");
            }
          })
          .catch(() => {
            bus.$emit("toggleLoader", false);
            self.showSnackbar("Something went wrong!", "error", "top");
          });
      }
    },
  },
};
</script>
